import styled from 'styled-components'

const Styled = styled.div`

`

export default Styled
